// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live {
  width: 100%;
  height: 100%; }
  .live__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px; }
    .live__title h1 {
      font-weight: 600;
      font-size: 32px;
      line-height: 150%; }
  .live__data-button {
    background: #e0e0e0;
    border-radius: 4px;
    padding: 8px 12px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 16px; }
    .live__data-button:hover {
      background: #b4b4b4; }
  .live__container {
    width: 100%;
    height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
    justify-content: space-between; }
  .live__reports {
    max-height: calc(100% - 110px);
    min-height: 50%;
    height: max-content;
    width: 100%;
    display: flex;
    gap: 14px;
    margin-bottom: 10px; }
  .live__camera {
    display: flex;
    flex-direction: column;
    width: 25%;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);
    border-radius: 4px;
    padding: 10px; }
    .live__camera_container {
      display: flex;
      flex-direction: column;
      overflow: auto; }
    .live__camera_filter {
      position: relative;
      margin: 10px 0;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px; }
      .live__camera_filter svg {
        position: absolute;
        right: 1px; }
      .live__camera_filter input {
        width: 100%;
        height: 100%;
        border: none;
        border-bottom: 1px solid #212121;
        outline: none;
        padding-right: 30px; }
        .live__camera_filter input:focus {
          border-bottom: 1px solid #fe6100; }
    .live__camera_item {
      padding: 10px 5px;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      border-bottom: 1px solid #e0e0e0;
      cursor: pointer;
      transition: all 0.3s ease-in;
      border-radius: 5px; }
      .live__camera_item:hover {
        background-color: #e0e0e0; }
  .live__report-info {
    width: 75%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);
    position: relative;
    border-radius: 4px; }
    .live__report-info_list {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5;
      display: flex;
      gap: 5px;
      width: 100%;
      overflow-y: auto; }
      .live__report-info_list_item {
        min-width: 20%;
        max-width: 20%;
        border: 1px dashed black;
        border-radius: 4px;
        padding: 5px;
        transition: all 0.4s ease-in;
        cursor: pointer; }
        .live__report-info_list_item:hover {
          background-color: #b4b4b4; }
  .live__timeline {
    min-height: 110px;
    max-height: 110px;
    width: 100%;
    overflow: auto; }
  .live__active {
    background: rgba(254, 97, 0, 0.1); }
    .live__active:hover {
      background: rgba(254, 97, 0, 0.1); }
`, "",{"version":3,"sources":["webpack://./src/pages/live/live.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY,EAAA;EACZ;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB,EAAA;IAJpB;MAMG,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;EAGrB;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,mBAAmB,EAAA;IAPpB;MASG,mBAAmB,EAAA;EAGvB;IACE,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,8BAA8B,EAAA;EAEhC;IACE,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,SAAS;IACT,mBAAmB,EAAA;EAErB;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,+CAA+C;IAC/C,kBAAkB;IAClB,aAAa,EAAA;IACb;MACE,aAAa;MACb,sBAAsB;MACtB,cAAc,EAAA;IAEhB;MACE,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;MALlB;QAOO,kBAAkB;QAClB,UAAU,EAAA;MARjB;QAWG,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,gCAAgC;QAChC,aAAa;QACb,mBAAmB,EAAA;QAhBtB;UAkBK,gCAAgC,EAAA;IAItC;MACE,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,gCAAgC;MAChC,eAAe;MACf,4BAA4B;MAC5B,kBAAkB,EAAA;MARnB;QAUG,yBAAyB,EAAA;EAI/B;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,+CAA+C;IAC/C,kBAAkB;IAClB,kBAAkB,EAAA;IAClB;MACE,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,UAAU;MACV,aAAa;MACb,QAAQ;MACR,WAAW;MACX,gBAAgB,EAAA;MAChB;QACE,cAAc;QACd,cAAc;QACd,wBAA+B;QAC/B,kBAAkB;QAClB,YAAY;QACZ,4BAA4B;QAC5B,eAAe,EAAA;QAPhB;UASG,yBAAyB,EAAA;EAKjC;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,cAAc,EAAA;EAEhB;IACE,iCAAiC,EAAA;IADlC;MAGG,iCAAiC,EAAA","sourcesContent":[".live {\n  width: 100%;\n  height: 100%;\n  &__title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    h1 {\n      font-weight: 600;\n      font-size: 32px;\n      line-height: 150%;\n    }\n  }\n  &__data-button {\n    background: #e0e0e0;\n    border-radius: 4px;\n    padding: 8px 12px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-radius: 16px;\n    &:hover {\n      background: #b4b4b4;\n    }\n  }\n  &__container {\n    width: 100%;\n    height: calc(100vh - 120px);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  &__reports {\n    max-height: calc(100% - 110px);\n    min-height: 50%;\n    height: max-content;\n    width: 100%;\n    display: flex;\n    gap: 14px;\n    margin-bottom: 10px;\n  }\n  &__camera {\n    display: flex;\n    flex-direction: column;\n    width: 25%;\n    height: 100%;\n    background: #ffffff;\n    box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);\n    border-radius: 4px;\n    padding: 10px;\n    &_container {\n      display: flex;\n      flex-direction: column;\n      overflow: auto;\n    }\n    &_filter {\n      position: relative;\n      margin: 10px 0;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 24px;\n        svg{\n            position: absolute;\n            right: 1px;\n        }\n      input {\n        width: 100%;\n        height: 100%;\n        border: none;\n        border-bottom: 1px solid #212121;\n        outline: none;\n        padding-right: 30px;\n        &:focus {\n          border-bottom: 1px solid #fe6100;\n        }\n      }\n    }\n    &_item {\n      padding: 10px 5px;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      border-bottom: 1px solid #e0e0e0;\n      cursor: pointer;\n      transition: all 0.3s ease-in;\n      border-radius: 5px;\n      &:hover {\n        background-color: #e0e0e0;\n      }\n    }\n  }\n  &__report-info {\n    width: 75%;\n    height: 100%;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);\n    position: relative;\n    border-radius: 4px;\n    &_list {\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: 5;\n      display: flex;\n      gap: 5px;\n      width: 100%;\n      overflow-y: auto;\n      &_item {\n        min-width: 20%;\n        max-width: 20%;\n        border: 1px dashed rgb(0, 0, 0);\n        border-radius: 4px;\n        padding: 5px;\n        transition: all 0.4s ease-in;\n        cursor: pointer;\n        &:hover {\n          background-color: #b4b4b4;\n        }\n      }\n    }\n  }\n  &__timeline {\n    min-height: 110px;\n    max-height: 110px;\n    width: 100%;\n    overflow: auto;\n  }\n  &__active {\n    background: rgba(254, 97, 0, 0.1);\n    &:hover {\n      background: rgba(254, 97, 0, 0.1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
